import { useEffect } from 'react';

import { implog } from '@/api/implog';
import pwaBg from '@/assets/modal/pwa_modal_bg_10.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import { installPwa } from '@/Layout/download/event';
import { modalStore } from '@/stores/modal';
import { isInIPA } from '@/utils/apk';
import { inPwaEnv } from '@/utils/utils';

import styles from './styles.module.less';

const PwaModal = (modal, onClose, innerProps) => {
  useEffect(() => {
    implog('pwa_modal_show', { ...innerProps, inIpa: isInIPA(), inPwa: inPwaEnv() });
  }, []);

  return (
    <div className={styles.main}>
      <BlurryLoadingImage loading="lazy" className={styles.img} src={pwaBg} />
      <div className={styles.box}>
        <div className={styles.text}>Add to desktop get</div>
        <div className={styles.text}>
          <span className={styles.money}>$5</span>
        </div>
        <div className={styles.text}>Start games faster</div>
        <div className={styles.subtext}>Save your account without losing it</div>
        <div className={styles.btn_box}>
          <Button
            size="large"
            type="success"
            block
            onClick={() => {
              installPwa();
              implog('pwa_modal_click', { ...innerProps, inIpa: isInIPA(), inPwa: inPwaEnv() });
              modalStore.closeTaskChain();
              modalStore.closeModal('pwa-modal');
            }}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PwaModal;
